/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".field_c4544792{text-decoration:none;text-overflow:ellipsis;overflow:hidden}.display_c4544792{cursor:pointer;white-space:nowrap}.nofill_c4544792{position:relative;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.disabledField_c4544792{opacity:0.4}\n"}]);
export const field = "field_c4544792";
export const display = "display_c4544792";
export const nofill = "nofill_c4544792";
export const disabledField = "disabledField_c4544792";